/**
 * Authentication Routes
 * All auth-related views are in this domain
 */
export default [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth-login" */ './views/Login.vue'),
        meta: {
            requiresNotAuth: true
        }
    },

    {
        path: '/signup',
        name: 'signup',
        component: () => import(/* webpackChunkName: "auth-signup" */ './views/Signup.vue'),
        meta: {
            requiresNotAuth: true
        }
    },

    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "auth-reset-password" */ './views/ResetPassword.vue'),
        meta: {
            requiresNotAuth: true
        }
    },
]
